/**
 * Maximum lengths for every free-text field the user can type into, mirroring the FluentValidation
 * rules on the API. Keep the two in sync: the input `maxLength` is the friendly stop, the API rule is
 * the one that actually protects the database.
 */
const fieldLimits = {
	billingAddress: 512,
	city: 120,
	comment: 4000,
	country: 120,
	customerName: 120,
	customPropertyKey: 100,
	customPropertyValue: 2000,
	email: 256,
	entityTitle: 200,
	fullName: 50,
	genderOther: 100,
	otpCode: 8,
	password: 128,
	phoneNumber: 32,
	pinCode: 16,
	referenceLink: 1000,
	search: 200,
	supportMessage: 4000,
	supportName: 100,
	supportSubject: 200,
	treeDescription: 2000,
	treeTitle: 150,
	state: 120
} as const;

export default fieldLimits;
